// src/pages/GroupPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GroupCreateModal, GroupList } from '../features/groups';
import Page from '../components/Page';
import '../styles/GroupPage.css';

const GroupPage = () => {
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleCreateClick = () => {
    setIsCreateModalOpen(true);
  };

  const handleModalClose = () => {
    setIsCreateModalOpen(false);
  };

  const handleGroupCreated = (newGroup) => {
    setIsCreateModalOpen(false);
    // Navigate to the newly created group
    navigate(`/groups/${newGroup.id}`);
  };

  return (
    <Page width="narrow" safeArea="none" className="group-page">
      <GroupList onCreateGroup={handleCreateClick} />

      {isCreateModalOpen && (
        <GroupCreateModal
          onClose={handleModalClose}
          onGroupCreated={handleGroupCreated}
        />
      )}
    </Page>
  );
};

export default GroupPage;
